import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'
import '../utilities/xhr-error-message'

class ErrorModal {
    
    /**
     * Construct module
     * @param container
    */
    constructor(container) {
        
        /**
         * Container jQuery object
         * @type {object}
        */
        this.container = container
        
        /**
         * Title jQuery object
         * @type {object}
        */
        this.title = jQuery('#error-modal-title')
        
        /**
         * Content jQuery object
         * @type {array}
        */
        this.content = jQuery('#error-modal-content')
        
        this.bindEvents()
        
    }
    
    /**
     * Run component
    */
    run() {
        if (typeof errors != 'undefined' && Array.isArray(errors)) {
            this.showModal({
                errors: errors
            })
        }
    }
    
    /**
     * Show modal
     * @params params
    */
    showModal(params) {
        
        var
            html,
            ulHtml = '<ul class="mb-0 word-break">'
            
        if (params.hasOwnProperty('html')) {
            html = params.html
        }
        else if (params.hasOwnProperty('xhr')) {
            
            var errors
            
            html = ulHtml
            
            //Load error messages from XHR response
            EventBus.publish('xhr-error-message', {
                xhr: params.xhr,
                callback: (messages) => {
                    errors = messages
                }
            })
            
            //Compile error messages in to list
            jQuery.each(errors, (i, error) => {
                html += '<li>' + error + '</li>'
            })
            
            html += '</ul>'
            
        }
        else if (params.hasOwnProperty('validator')) {
            
            let
                form = jQuery(params.validator.currentForm),
                input,
                label
                
            //Define boolean for address error logic
            var addressError = false
            
            if (form.length > 0) {
                
                html = ulHtml
                
                //Loop through errors
                jQuery.each(params.validator.submitted, (key, description) => {
                    
                    if (!key) {
                        return
                    }
                    
                    //Special logic for address errors
                    if (key.startsWith('address[')) {
                        addressError = true
                        return
                    }
                    
                    input = form.find('[name="' + key + '"]')
                    if (input.length === 0) {
                        return
                    }
                    
                    //Skip if input has "valid" class (due to bug)
                    if (input.hasClass('valid')) {
                        return
                    }
                    
                    //Attempt to get text from input's data-attribute
                    let text = input.data('required-text')
                    
                    if (!text) {
                    
                        //Attempt to get text from label
                        
                        label = form.find('label[for="' + input.attr('id') + '"]').first()
                        if (label.length === 0) {
                            return
                        }
                        
                        text = label.clone().children().remove().end().text().trim()
                    
                    }
                    
                    html += '<li><strong>' + text + ':</strong> ' + description + '</li>'
                    
                })
                
                //Add custom Address error if present
                if (addressError) {
                    html += '<li><strong>' + addressLabel + ':</strong> ' + addressErrorText + '</li>'
                }
                
                html += '</ul>'
                params.title = errorModalFormTitle
                
            }
            
        }
        else if (params.hasOwnProperty('errors')) {
            
            html = ulHtml

            //Compile error messages in to list
            jQuery.each(params.errors, (i, error) => {
                html += '<li>' + error + '</li>'
            })
            
            html += '</ul>'
            
        }
        else if (params.hasOwnProperty('error')) {
            html = '<p>' + params.error + '</p>'
        }
        
        this.title.text(params.hasOwnProperty('title') ? params.title : errorModalDefaultTitle)
        this.content.html(html)
        this.container.modal('show')
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Run component
        EventBus.subscribe('run-modules', this.run.bind(this))
        
        //Show confirmation
        EventBus.subscribe('error', this.showModal.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let container = jQuery('#error-modal')
    
    if (container.length > 0) {
        new ErrorModal(container)
    }
    
})

export default ErrorModal